import { Routes } from '@angular/router';
import { LessonComponent } from './lesson/lesson.component';
import { LessonManagementComponent } from './lesson-management/lesson-management.component';
import { exerciseRoutes } from '../exercise/exercise.routes';

export const lessonRoutes: Routes = [
  {
    path: 'lessons',
    canActivate: [],
    data: {
      breadcrumb: {}
    },
    children: [
      {
        path: 'create',
        component: LessonComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'Create',
            value: 'Lessons',
            type: 'Lesson'
          }
        }
      },
      {
        path: ':lessonId',
        data: {
          breadcrumb: {
            bcType: 'LookUp',
            value: 'lessonId',
            type: 'Lesson'
          }
        },
        children: [
          {
            path: 'edit',
            component: LessonComponent,
            data: {
              type: 'edit',
              breadcrumb: {
                bcType: 'Display',
                action: 'Edit'
              }
            }
          },
          {
            path: 'manage',
            component: LessonManagementComponent,
            data: {
              breadcrumb: {
                bcType: 'Display',
                action: 'Manage',
              }
            }
          },
          ...exerciseRoutes
        ]
      }
    ]
  },
];
